import * as z from 'zod';
/**
 * Apply a populate profile to a query based on the populate level.
 *
 * @example
 * ```ts
 * const drugCatalogItemPopulates: PopulateProfiles<'drugCatalogItems'> = {
 *   minimal: null,
 *   list: (q) => q.related('activeSubstanceDetails', ...).related('categories', ...),
 *   full: (q) => q.related('activeSubstanceDetails', ...).related('medicationProfiles', ...),
 * }
 *
 * // In query definition:
 * q = applyPopulate(q, drugCatalogItemPopulates, args.populate)
 * ```
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function applyPopulate(q, profiles, level = 'list') {
    const profile = profiles[level];
    if (profile === null) {
        return q;
    }
    return profile(q);
}
/**
 * Create a zod enum schema for a populate level.
 * @param defaultLevel - The default populate level (defaults to 'list')
 */
export function createPopulateSchema(defaultLevel = 'list') {
    return z.enum(['minimal', 'list', 'full']).default(defaultLevel);
}
//# sourceMappingURL=populates.js.map